export const allowsImageUpload = types =>
  !types?.length || types.includes(1);

export const isHttpUrl = value =>
  typeof value === "string" && /^https?:\/\//i.test(value);

export const mediaFromUploadedUrl = (url, fileName) => ({
  id: url,
  title: fileName,
  preview_url: url,
  public_url: url,
  tags: [],
});

export const mediaDisplayUrl = mediaOrId => {
  if (mediaOrId == null) return null;
  if (typeof mediaOrId === "string" || typeof mediaOrId === "number") {
    return isHttpUrl(String(mediaOrId)) ? String(mediaOrId) : null;
  }
  return (
    mediaOrId.preview_url ||
    mediaOrId.public_url ||
    (isHttpUrl(mediaOrId.id) ? mediaOrId.id : null) ||
    null
  );
};

export const resolveStoredMedia = async (id, fetchCms) => {
  if (id == null || id === "") return null;
  const url = mediaDisplayUrl(id);
  if (url) {
    return { id, public_url: url, preview_url: url };
  }
  return fetchCms(id);
};
